import SurveySearcher from './SurveySearcher.jsx';

export default SurveySearcher;